import { LogManager } from '../../../common';
import { OrgWorkingSessionsEntityMapper } from '../../../infrastructure/mappers/working-sessions/org-working-sessions.entity.mapper';
import { SelfWorkingSessionsEntityMapper } from '../../../infrastructure/mappers/working-sessions/self-working-sessions.entity.mapper';
import { GetUserWorkingSessionsRequestDto } from '../../dtos/working-sessions/user/get-user-working-sessions.request.dto';
import { GetUserWorkingSessionsResponseDto } from '../../dtos/working-sessions/user/get-user-working-sessions.response.dto';
import { GetUserWorkingSessionsQuery } from '../../queries/working-sessions/get-user-working-sessions.query';

export class GetUserWorkingSessionsController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetUserWorkingSessionsQuery,
    protected readonly mapper: OrgWorkingSessionsEntityMapper
  ) {}

  async get(
    props: GetUserWorkingSessionsRequestDto
  ): Promise<GetUserWorkingSessionsResponseDto[]> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `GetUserWorkingSessionsController.get encountered an error ${error}`
      );
    }
  }
}
